<template>
  <form-wrapper :validator="$v.data">
    <section class="content-body">
      <b-row class="form-group">
        <b-col cols="4">
          <label>Telephone</label>
        </b-col>
        <b-col cols="8">
          <BaseInput type="number" v-model="data.telephone" />
        </b-col>
      </b-row>
      <b-row class="form-group">
        <b-col cols="4">
          <label>Phone</label>
        </b-col>
        <b-col cols="8">
          <BaseInput type="number" v-model="data.phone" />
        </b-col>
      </b-row>
      <b-row class="form-group">
        <b-col cols="4">
          <label>Email</label>
        </b-col>
        <b-col cols="8">
          <BaseInput v-model="data.email" />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="8" class="offset-md-4">
          <b-button size="sm" @click="save" variant="primary" name="add">
            Save
          </b-button>
          <b-button size="sm" @click="clear" variant="light" name="clear"
            >Clear</b-button
          >
        </b-col>
      </b-row>
    </section>
  </form-wrapper>
</template>

<script>
import BaseInput from "@/components/base/Input";

// Validations
import { required, helpers, email } from "vuelidate/lib/validators";
const phoneNumber = helpers.regex("phoneNumber", /^\d{9,10}$/);

export default {
  components: {
    BaseInput,
  },
  props: {
    data: {
      type: Object,
      default: {},
    },
  },
  methods: {
    clear() {
      this.$emit("clearContact");
      this.$v.$reset();
    },
    clearValidations() {
      this.$v.$reset();
    },
    save() {
      if (this.isValid()) {
        this.$v.$reset();
        this.$emit("saveContact", this.data);
      }
    },
    isValid() {
      this.$v.$touch(); // it will validate all fields
      let status = !this.$v.$invalid;
      this.$emit("valid", status);
      if (this.$v.$invalid) return false;
      return true;
    },
  },
  validations: {
    data: {
      telephone: { required, phoneNumber },
      phone: { required, phoneNumber },
      email: { required, email },
    },
  },
};
</script>
